import React from "react";
// types
import { TMainPageLayoutV2 } from "../type";


const MNPG001 = ( props:TMainPageLayoutV2 ) => {
    console.log("MNPG001.rendered: ", props);
    return null;
}

const Component = React.memo(MNPG001, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG001.memo", { prevProps, nextProps });
    return true;
});

export default Component;